module.exports = __webpack_public_path__ + "static/img/backIcon.dd0baa69.png";